/**
 * Валюта по стране страницы (как в config.py: DK=DKK, RO=RON, остальные EUR).
 * Цена с бэка хранится в валюте страны: для DK — кроны, для RO — леи, для остальных — евро.
 */

export const PRIMARY_BY_COUNTRY = {
  DK: 'DKK',
  RO: 'RON',
  NL: 'EUR',
  PL: 'PLN',
  CZ: 'CZK',
  LT: 'EUR',
  LV: 'EUR',
  AT: 'EUR',
  ES: 'EUR',
  PT: 'EUR',
  FR: 'EUR',
  IT: 'EUR',
  IE: 'EUR',
  BE: 'EUR',
  DE: 'EUR',
  FI: 'EUR',
  GB: 'GBP',
  HR: 'EUR',
  BG: 'EUR',
  CH: 'CHF',
  BA: 'BAM',
  HU: 'HUF',
  IS: 'ISK',
  SK: 'EUR',
  SE: 'SEK',
  NO: 'NOK',
  MD: 'MDL',
  EE: 'EUR',
};

/** Название страны для отображения (англ.), если с бэка не пришло country_name */
export const COUNTRY_DISPLAY_NAME = {
  DK: 'Denmark',
  RO: 'Romania',
  NL: 'Netherlands',
  PL: 'Poland',
  CZ: 'Czechia',
  LT: 'Lithuania',
  LV: 'Latvia',
  AT: 'Austria',
  ES: 'Spain',
  PT: 'Portugal',
  FR: 'France',
  IT: 'Italy',
  IE: 'Ireland',
  BE: 'Belgium',
  DE: 'Germany',
  FI: 'Finland',
  GB: 'United Kingdom',
  HR: 'Croatia',
  BG: 'Bulgaria',
  CH: 'Switzerland',
  BA: 'Bosnia and Herzegovina',
  HU: 'Hungary',
  IS: 'Iceland',
  SK: 'Slovakia',
  SE: 'Sweden',
  NO: 'Norway',
  MY: 'Malaysia',
  MD: 'Moldova',
  EE: 'Estonia',
};

export const CURRENCY_SYMBOL = {
  EUR: '€',
  USD: '$',
  DKK: 'kr',
  RON: 'lei',
  PLN: 'zł',
  CHF: 'CHF',
  BAM: 'KM',
  CZK: 'Kč',
  HUF: 'Ft',
  ISK: 'kr',
  SEK: 'kr',
  NOK: 'kr',
  MYR: 'RM',
  GBP: '£',
  MDL: 'L',
};

/** Курс от EUR к другой валюте (1 EUR = X единиц валюты) */
export const EUR_TO = {
  EUR: 1,
  USD: 1.08,
  DKK: 7.45,
  RON: 4.97,
  PLN: 4.3,
  /** ~1 EUR ≈ 25.0 CZK (курс ориентировочный) */
  CZK: 25.0,
  /** ~1 EUR ≈ 0.94 CHF (курс ориентировочный для convertToUsd) */
  CHF: 0.94,
  /** 1 EUR ≈ 1.95583 BAM (konvertibilna marka) */
  BAM: 1.95583,
  /** ~1 EUR ≈ 395 HUF (orientációs árfolyam) */
  HUF: 395,
  /** ~1 EUR ≈ 152 ISK (áætlað) */
  ISK: 152,
  /** ~1 EUR ≈ 11.5 SEK (orientacyjny kurs) */
  SEK: 11.5,
  /** ~1 EUR ≈ 11.8 NOK (orientacyjny kurs) */
  NOK: 11.8,
  /** ~1 EUR ≈ 5.0 MYR (orientacyjny kurs) */
  MYR: 5.0,
  GBP: 0.85,
  MDL: 19.5,
};

export function getPrimaryCurrency(countryCode) {
  return PRIMARY_BY_COUNTRY[countryCode?.toUpperCase()] || 'EUR';
}

/** Название страны для статичного поля: из page или по коду */
export function getCountryDisplayName(countryCode, countryNameFromPage) {
  if (countryNameFromPage && String(countryNameFromPage).trim()) return countryNameFromPage.trim();
  return COUNTRY_DISPLAY_NAME[countryCode?.toUpperCase()] || '—';
}

/** Конвертация из валюты страницы в USD (цена с бэка уже в валюте страны) */
export function convertToUsd(amountInPrimary, primaryCurrency) {
  if (!amountInPrimary && amountInPrimary !== 0) return 0;
  const rateToEur = EUR_TO[primaryCurrency];
  if (!rateToEur) return amountInPrimary;
  const eur = amountInPrimary / rateToEur;
  return Math.round(eur * EUR_TO.USD * 100) / 100;
}

/** Конвертация из USD в валюту (для отображения при выборе USD) */
export function convertFromEur(amountEur, currency) {
  const rate = EUR_TO[currency];
  if (rate == null) return amountEur;
  return Math.round(amountEur * rate * 100) / 100;
}

export function getSymbol(currency) {
  return CURRENCY_SYMBOL[currency] || currency;
}

/** Строка курса для подписи: "1 USD = X EUR" или "1 USD = X kr" */
export function getRateLabel(primaryCurrency) {
  if (primaryCurrency === 'USD') return null;
  const rate = EUR_TO[primaryCurrency];
  const usdToPrimary = rate && EUR_TO.USD ? (rate / EUR_TO.USD) : 0;
  const sym = getSymbol(primaryCurrency);
  return `1 USD = ${usdToPrimary.toFixed(4)} ${sym}`;
}
